import { useInjectPanel } from '../PanelContext';
import { getLastDay } from '../utils/timeUtil';
import { getCellDateDisabled } from '../utils/dateUtil';
import classNames from '../../_util/classNames';
import useMergeProps from '../hooks/useMergeProps';
function PanelBody(_props) {
    const { prefixCls, disabledDate, onSelect, picker, rowNum, colNum, noEvent, hiddenWeekend, fromCalendar, prefixColumn, rowClassName, baseDate, viewDate, getCellClassName, getCellText, getCellNode, getCellDate, generateConfig, titleCell, headerCells, } = useMergeProps(_props);
    const { onDateMouseenter, onDateMouseleave, mode } = useInjectPanel();
    const cellPrefixCls = `${prefixCls}-cell`;
    // =============================== Body ===============================
    const rows = [];
    let trNum = 0;
    for (let i = 0; i < rowNum; i += 1) {
        const row = [];
        let rowStartDate;
        let mondayAndFridayHiddenNum = 0;
        for (let j = 0; j < colNum; j += 1) {
            const offset = i * colNum + j;
            const currentDate = getCellDate(baseDate, offset);
            const disabled = getCellDateDisabled({
                cellDate: currentDate,
                mode: mode.value,
                disabledDate,
                generateConfig,
            });
            const hidden = mode.value === 'date' &&
                fromCalendar &&
                generateConfig.getMonth(viewDate) !== generateConfig.getMonth(currentDate);
            // 周末不显示时，周一和周五都隐藏了当行就隐藏
            if ((j === 0 || j === 4) && hidden && hiddenWeekend) {
                mondayAndFridayHiddenNum++;
            }
            // 周末显示时，周一和周日都隐藏了当行就隐藏
            if ((j === 0 || j === 6) && hidden && !hiddenWeekend) {
                mondayAndFridayHiddenNum++;
            }
            if (j === 0) {
                rowStartDate = currentDate;
                if (prefixColumn) {
                    row.push(prefixColumn(rowStartDate));
                }
            }
            const title = titleCell && titleCell(currentDate);
            row.push(<td key={j} 
            // title={title}
            class={classNames(cellPrefixCls, {
                    [`${cellPrefixCls}-disabled`]: disabled,
                    [`${cellPrefixCls}-hidden`]: hidden,
                    [`${cellPrefixCls}-no-event`]: noEvent,
                    [`${cellPrefixCls}-start`]: getCellText(currentDate) === 1 || (picker === 'year' && Number(title) % 10 === 0),
                    [`${cellPrefixCls}-end`]: title === getLastDay(generateConfig, currentDate) ||
                        (picker === 'year' && Number(title) % 10 === 9),
                    ...getCellClassName(currentDate),
                })} onClick={() => {
                    if (!disabled && !noEvent) {
                        onSelect(currentDate);
                    }
                }} onMouseenter={() => {
                    if (!disabled && onDateMouseenter && !noEvent) {
                        onDateMouseenter(currentDate);
                    }
                }} onMouseleave={() => {
                    if (!disabled && onDateMouseleave && !noEvent) {
                        onDateMouseleave(currentDate);
                    }
                }}>
          {getCellNode ? (getCellNode(currentDate)) : (<div class={`${cellPrefixCls}-inner`}>{getCellText(currentDate)}</div>)}
        </td>);
        }
        if (mondayAndFridayHiddenNum < 2 || !fromCalendar) {
            trNum++;
            rows.push(<tr key={i} class={rowClassName && rowClassName(rowStartDate)}>
          {row}
        </tr>);
        }
    }
    return (<div class={`${prefixCls}-body`}>
      <table class={`${prefixCls}-content`}>
        {headerCells && (<thead>
            <tr>{headerCells}</tr>
          </thead>)}
        <tbody class={`tbody-${trNum}`}>{rows}</tbody>
      </table>
    </div>);
}
PanelBody.displayName = 'PanelBody';
PanelBody.inheritAttrs = false;
export default PanelBody;
